import types from './types';

export default {

    switchType: () =>  ({
        type: types.SWITCH_TYPE
    }),

};
